import { ChevronDownIcon, ChevronRightIcon } from '@primer/octicons-react';
import { Box, Checkbox, IconButton } from '@primer/react';
import { useContext, useRef } from 'react';
import { useElementPosition } from '../../../hooks/useElementPosition';
import { DataTableContainerContext, IDataTableContext, ISelectionProps } from './DataTable';
import styles from "./DataTable.module.css";
import { useCommonContext } from '../../../contexts/common';
interface IGroupRowProps {
    selection?: ISelectionProps,
    row: any
}
const GroupRow = (props: IGroupRowProps) => {
    const { row, selection, } = props;
    const { filterdData, expandedGroupValue, setExpandedGroupValue, wrapperRef
    } = useContext<IDataTableContext>(DataTableContainerContext);
    const groupValueField = row.original.groupValueField;
    const { translate } = useCommonContext();;
    const groupValue = row.original.groupValue
    const groupDatas = filterdData.filter(x => x[groupValueField] === groupValue);
    const isExpanded = expandedGroupValue && expandedGroupValue.includes(groupValue);

    const wrapPosition = useElementPosition(wrapperRef);

    const groupRef = useRef<any>();
    const groupPosition = useElementPosition(groupRef)
    const caption = row.cells.find((x: any) => x.column.dataField === groupValueField)?.column.caption
    // console.log({
    //     wrapPosition,
    //     groupPosition
    // });
    return (
        <>

            <td
                // colSpan={row.cells.length - (selection && selection.mode === "multiple" ? 1 : 0)}
                colSpan={row.cells.length}
                style={{
                    fontWeight: "bold",
                    backgroundColor: "#F5F8FA",
                }}
                className={styles.fixed_column}
            >
                <Box
                    ref={groupRef}
                    sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        mt: -1,
                        mb: -1,
                        paddingLeft: `${wrapPosition.x - groupPosition.x}px`
                        // position: "sticky",
                        // left: 0

                    }}

                >
                    {selection && selection.mode === "multiple" &&
                        <Box style={{
                            fontWeight: "bold",
                            backgroundColor: "#F5F8FA",
                            // width: "40px",
                            marginLeft: "40px",
                            // display: "flex",
                            // justifyContent: "center"
                        }}>
                            <Checkbox
                                checked={
                                    groupDatas.filter((g) => !g.disabled).length > 0 &&
                                    groupDatas
                                        .filter((g) => !g.disabled)
                                        .find(
                                            (x) =>
                                                !(props.selection?.selectedRowKeys ?? []).includes(x.id)
                                        ) === undefined
                                }
                                onChange={(e) => {
                                    const ids = groupDatas
                                        .filter((g) => !g.disabled)
                                        ?.map((x) => x.id);
                                    if (e.target.checked) {
                                        props.selection?.onSelectionChanged(
                                            Array.from(
                                                new Set([
                                                    ...(props.selection?.selectedRowKeys ?? []),
                                                    ...ids,
                                                ])
                                            )
                                        );
                                    } else {
                                        props.selection?.onSelectionChanged(
                                            Array.from(
                                                new Set(
                                                    (props.selection?.selectedRowKeys ?? []).filter(
                                                        (x) => !ids.includes(x)
                                                    )
                                                )
                                            )
                                        );
                                    }
                                }}
                            />
                        </Box>
                    }
                    <IconButton icon={isExpanded ? ChevronDownIcon : ChevronRightIcon} aria-label='' variant='invisible' size='small'
                        onClick={() => {
                            if (isExpanded) {
                                setExpandedGroupValue?.([...(expandedGroupValue ?? []).filter(x => x !== groupValue)])
                            } else {
                                setExpandedGroupValue?.([...(expandedGroupValue ?? []), groupValue])
                            }
                        }}
                    />
                    <Box sx={{ flex: 1 }}>
                        {translate(caption)}:    {row.original.groupValue}
                    </Box>
                </Box>

            </td>
        </>
    );
};

export default GroupRow;